export default class Enable extends CustomEvent {
    constructor(caller) {
        super('enable', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
